import React, { useEffect, useState } from 'react'
import BusinessStyles from './EditHomeBanner.module.css'
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'

const EditHomeBanner = () => {

  
const name=useSelector((state)=>state.globalData.name);
const count=useSelector((state)=>state.globalData.notificationCount);
const dispatch=useDispatch();


  const location = useLocation()
  const data = location.state
  console.log(data)

  const navigate = useNavigate()

  const inputRef = React.useRef();

  const [file, setFile] = useState(null)
  const [source, setSource] = React.useState();
  const [fileName, setFileName] = React.useState('');
  const [imageSelect, setImageSelect] = useState(false)

  const [bannerName, setbannerName] = useState('')
  const [bannerDescription, setbannerDescription] = useState('')
  const [bannerBtnLink, setbannerBtnLink] = useState('')

  useEffect(() => {
    if (data) {
      setbannerName(data.banner.bannerName)
      setbannerDescription(data.banner.bannerDescription)
      setbannerBtnLink(data.banner.bannerBtnLink)
    }
  }, [data])


  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFileName(file.name)
    const url = URL.createObjectURL(file);
    setSource(url);
    setImageSelect(true)
    setFile(file)
  };

  const handleChoose = (event) => {
    inputRef.current.click();
  };

  const discardImage = (event) => {
    setSource(null)
    setFileName('')
    setFile(null)
    inputRef.current.value = ""
    setImageSelect(false)
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    const formDataObj = new FormData()
    formDataObj.append("file", file)
    formDataObj.append("bannerName", bannerName)
    formDataObj.append("bannerDescription", bannerDescription)
    formDataObj.append("bannerBtnLink", bannerBtnLink)

    try {
      const imageResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/banner/updateBannerImagebyId/${data.imgId}`,
        formDataObj,
        {
          headers: {
            "Content-Type": "image/jpeg"
          }
        }
      )
      // console.log(imageResponse)
    } catch (error) {
      console.error(error)
    }
    try {

      const businessResponse = await axios.post(
        `${process.env.REACT_APP_STEELADMIN}/banner/updateBannerDetails/${data.banner.bannerId}`,
        {bannerName, bannerDescription, bannerBtnLink},
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      // console.log('Banner Updated.')
      // console.log(businessResponse)
     
    } catch (error) {
      console.error(error)
    }
    alert('Banner Updated.')

    dispatch(fetchNotifications())

    dispatch(setNotificationCount({
      count:count+1,
     }))
    discardImage()
    navigate('/homebanner')
  }


    useEffect(() => {
    const fetchImage = async () => {
      try {
        const imageResponse = await axios.get(
          `${process.env.REACT_APP_STEELADMIN}/banner/file/${data.bannerImageName}`
        );
        // console.log(imageResponse);
        setSource(imageResponse);
      } catch (error) {
        console.error(error);
      }
    };

    fetchImage();
  }, [data.bannerImageName]);


  return (
    <div className={BusinessStyles.businessMain}>
      <div className={BusinessStyles.businessContent}>
        <form action="" className={BusinessStyles.businessForm} onSubmit={handleSubmit} encType='multipart/form-data'>
          <label className={BusinessStyles.businessFormLabel}>Title</label>
          <input className={BusinessStyles.businessFormText} type="text" value={bannerName} name='bannerName' onChange={(event) => setbannerName(event.target.value)} />
          <label className={BusinessStyles.businessFormLabel}>Description</label>
          <textarea className={BusinessStyles.businessFormDesc} value={bannerDescription} name='bannerDescription' onChange={(event) => setbannerDescription(event.target.value)} />
          <label className={BusinessStyles.businessFormLabel}>Link</label>
          <input className={BusinessStyles.businessFormText} type="text" value={bannerBtnLink} name='bannerBtnLink' onChange={(event) => setbannerBtnLink(event.target.value)} />
          <label className={BusinessStyles.businessFormLabel}>Upload</label>
          <div className={BusinessStyles.ImgInput}>
            <input
              ref={inputRef}
              className={BusinessStyles.ImgInput_input}
              type="file"
              onChange={handleFileChange}
            />
            {!source && <button type='button' onClick={handleChoose}>Browse</button>}
            {source && (
              <img
                className={BusinessStyles.ImgInput_img}
                width="100%"
                src={`${process.env.REACT_APP_STEELADMIN}/banner/file/${data.bannerImageName}`}
                alt='uploadedimage'
              />
              )}
              </div>
            <div className={BusinessStyles.ImgInput_footer}>
              {imageSelect ?
                <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                  {fileName}
                </div> :
                ''}
                <DeleteForeverOutlinedIcon onClick={discardImage} sx={{ cursor: 'pointer' }} />
            </div>
          <Button variant='contained' type='submit' className={BusinessStyles.saveChanges}>Save changes</Button>
        </form>
      </div>
    </div>
  )
}

export default EditHomeBanner